<template>
<panel>
  <p slot="header">
    {{ item.name }}
  </p>
  <p slot="actions">
    <ui-button type="flat" color="primary" @click="cancel">Anuluj</ui-button>
  </p>
  <templates-form :item="item" v-if="item.id"></templates-form>
</panel>
</template>

<script>
import Templates from './../../services/Templates'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      item: Templates.getBaseItem()
    }
  },
  mounted () {
    const id = this.$route.params.id
    this.getItem(id)
  },
  methods: {
    cancel () {
      this.$router.push({name: 'admin.templates.dashboard', params: {id: this.item.id}})
    },
    getItem (id) {
      this.setLoading(true)
      Templates.get(id).then((res) => {
        this.item = res.data.item
        this.setLoading(false)
      })
    }
  }
}

</script>


// WEBPACK FOOTER //
// Edit.vue?a30d5cd8